import { FC, useMemo } from 'react'
import useHover from 'hooks/useHover'
import { Tooltip, TooltipTrigger, TooltipContent } from '@wellesley/ui'

import { THeader } from '../types'
import getPrivacyOptions from '../../../PostForm/helpers/privacy/getPrivacyOptions'
import getFeedPrivacyIcon from '../helpers/getPrivacyIcon'
import getFeedPrivacyDescription from '../helpers/getPrivacyDescription'
import checkPrivacyOptionVariant from '../../../PostForm/helpers/privacy/checkPrivacyOptionVariant'

const PrivacyLabel: FC<Pick<THeader, 'feed' | 'privacyOptionsVariant'>> = ({
  feed,
  privacyOptionsVariant,
}) => {
  const [ref, isHovered] = useHover<HTMLButtonElement>()
  const isReply = feed.path.length > 0
  const privacyOptions = useMemo(
    () =>
      getPrivacyOptions({
        variant: checkPrivacyOptionVariant(privacyOptionsVariant, isReply),
      }),
    [privacyOptionsVariant],
  )
  const matchedOption = privacyOptions.find(
    (option) => option.key === feed.privacy,
  )
  const icon =
    matchedOption?.icon(16, isHovered) ||
    getFeedPrivacyIcon(feed.privacy, isHovered)
  const description =
    matchedOption?.description || getFeedPrivacyDescription(feed.privacy)

  return (
    <Tooltip disableHoverableContent>
      <TooltipTrigger ref={ref} className="h-5" asChild>
        {icon}
      </TooltipTrigger>
      <TooltipContent theme="dark" size="small" align="center">
        {description}
      </TooltipContent>
    </Tooltip>
  )
}

export default PrivacyLabel
